import { UserApiResponse } from '@interfaces/userApiResponse'

/**
 * Checks whether a user is logged in and returns user data by calling the `/api/user/details/` endpoint.
 *
 * @returns {Promise<{ isLoggedIn: boolean; user: UserApiResponse | null }>}
 *          - `isLoggedIn`: `true` if the API returns user details (status 200), otherwide `false`.
 *          - `user`: parsed user object if logged in, else `null`.
 */
export const checkIsLoggedIn = async (): Promise<{ isLoggedIn: boolean; user: UserApiResponse | null }> => {
  if (typeof window === 'undefined') {
    throw new Error('This function should only be called in client.')
  }
  try {
    const resp = await fetch('/api/user/details/', {
      next: { revalidate: 0 },
      credentials: 'include',
    })
    if (resp.status === 200) {
      const userData: UserApiResponse = (await resp.json()) || {
        addresses: [],
        amazon_prime: false,
        date_of_birth: null,
        email: '',
        name: '',
        phone: '',
        gender: '',
        whatsapp_optin: false,
        is_amazon: false,
      }
      return { isLoggedIn: true, user: userData }
    } else {
      return { isLoggedIn: false, user: null }
    }
  } catch (e) {
    console.log(e)
    return { isLoggedIn: false, user: null }
  }
}
